export default __webpack_public_path__ + "static/media/image-earphones-yx1.48e16a44.jpg";